import React from "react";
import {AppBar, Button, Tooltip} from "@mui/material";
import { useState } from "react";
import { NavLink, Routes, Route, BrowserRouter as Router} from "react-router-dom";
import LoginDialog from "../loginForm/loginForm";

import "./template.min.css";
import "./headerLayout.css";

import HomePage from "../../pages/home";
import ProjectPage from "../../pages/project";
import AuthService from "../../services/auth.service";
import ErrorPage from "../../pages/errorPage";
import DatabasePage from "../../pages/databasePage";
import AboutPage from "../../pages/about";

import c40_logo from "../../assets/c40_logo_correct.svg";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

function Home() {
  checkPathName();
  return <HomePage />;
}

function Databaseterms() {
  checkPathName();
  return <DatabasePage />;
}

function ShowErrorPage() {
  return (
    <>
      <ErrorPage />
    </>
  );
}

function Project() {
  checkPathName();
  const user = AuthService.getCurrentUser();
   return user ? <ProjectPage /> 
   : window.location.reload(true);
}

function About() {
  checkPathName();
   return <AboutPage />;
}

function checkPathName() {
 //console.log("Pathname=", window.location.pathname)
  if (window.location.pathname === "/")
    document.body.style.overflow = "hidden";
  //else if (window.location.pathname === "/project")
  //  document.body.style.overflowX = "hidden";
  else
    document.body.style= "";
}

function AppRouter() {
  const [currentUser, setCurrentUser] = React.useState(undefined);
  const [loginOpen, setLoginOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [error, setError] = useState("");
  // const navigate = useNavigate();

  const logOut = () => {
    AuthService.logout().then(
      () => {
        //navigate("/");
        setCurrentUser(undefined);
        localStorage.clear();
        window.location.reload();        
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        setError(resMessage);
      }
    );
  };

  React.useEffect(() => {
    const user = AuthService.getCurrentUser();
    //const user = "Test";
    //console.log("User=", user);
    if (user) {
      setCurrentUser(user);
    }
  }, []);

  return (
    <div>
      <Router>
        <AppBar position="static" className="header-appbar">
          {/* left: logo and the parts of the tool */}
          <div className="header-left">
            <a className="go-home" href="/">
                <img width = "82" height = "82" src={c40_logo}></img>  
            </a>
            <nav className="nav-main">
              <NavLink exact="true" activeclassname="active" to="/">
                Maps
              </NavLink>
              {currentUser ? (
                <NavLink activeclassname="active" to="/project">
                  Project
                </NavLink>
              ) : (
                <Tooltip
                  arrow
                  enterDelay={0}
                  componentsProps={{ tooltip: { className: "nav-disabled-tooltip" }, arrow: { className: "nav-disabled-tooltip-arrow" } }}
                  title={
                    <div className="nav-disabled-tip">
                      <div className="nav-disabled-tip-title">
                        <LockOutlinedIcon className="nav-disabled-tip-icon" /> Log in to use Projects
                      </div>
                      <p>Projects let you simulate urban actions and estimate their health, economic and emissions benefits.</p>
                      <button type="button" className="nav-disabled-tip-login" onClick={() => setLoginOpen(true)}>Log in here</button>
                      <p className="nav-disabled-tip-sub">No account yet?</p>
                      <a className="nav-disabled-tip-button" href="https://forms.gle/cxjJfa4piEKxdyV27" target="_blank" rel="noopener noreferrer">Request login details from C40</a>
                    </div>
                  }
                >
                  <a className="nav-disabled" role="link" aria-disabled="true" tabIndex={0}>
                    Project
                  </a>
                </Tooltip>
              )}
            </nav>
          </div>

          {/* right: the information pages, then login */}
          <div className="header-right">
            <nav className="nav-info">
              <NavLink activeclassname="active" to="/databaseterms">
                Database and Terms
              </NavLink>
              <NavLink activeclassname="active" to="/about">
                About
              </NavLink>
            </nav>
            <div id="btn-login">
              {currentUser ? (
                <Button variant="contained" sx={{ fontWeight: 600 }} onClick={logOut}>
                  Logout
                </Button>
              ) : (
                <LoginDialog open={loginOpen} onOpenChange={setLoginOpen} />
              )}
            </div>
          </div>
        </AppBar>

          <Routes>
            <Route path='/' element={<Home/>} />
            {currentUser ? (
              <Route path='/Project' element={<Project/>} />
            ) : (
              <Route path='/Project' element={<ShowErrorPage/>} />
            )}
            <Route path='/databaseterms' element={<Databaseterms/>} />
            <Route path='/about' element={<About/>} />
          </Routes>
      </Router>
    </div>
  );
}

export default AppRouter;